// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_DESCRIPTION_FORUM = "Miesto pre tvoje ot\u00e1zky, sk\u00fasenosti aj ka\u017edodenn\u00e9 radosti a starosti. Zapoj sa do diskusi\u00ed o v\u0161etkom, \u010do \u017eivot prin\u00e1\u0161a.";
export const SEO_TITLE_FORUM = "Diskusie";
